export default __webpack_public_path__ + "static/media/400_ml.8c1a7bd3.svg";